import type { AppDispatch } from '../reduxStore/store';
import { handleLogout } from '../reduxStore/store/auth';
import { clearCartList, removeCartList } from '../reduxStore/store/cart/index';
import { removeCustomerAddress } from '../reduxStore/store/order/index';

/**
 * Tear down everything belonging to the signed-in customer.
 *
 * There were two versions of this: the avatar menu cleared the session, the cart
 * and the saved address, while an expired token cleared only the session. They
 * drifted, and the gap was not cosmetic — the cart survives in localStorage, so
 * a customer whose token expired left their name and mobile on /cart for whoever
 * used the browser next. That visitor's next add-to-cart persisted the previous
 * customer's line items, and signing in posted the lot to /bulk-cart. Someone
 * could be shipped a physical card printed with another person's details.
 *
 * Both paths now call this, so a future addition cannot be remembered in one
 * place and forgotten in the other.
 *
 * `clearCartList` and `removeCartList` are both needed: the first empties the
 * slice and writes the empty list back to secure storage, the second drops the
 * raw `cartList` key. Either alone leaves a copy behind.
 */
export const clearCustomerSession = (dispatch: AppDispatch) => {
    dispatch(handleLogout());
    dispatch(clearCartList());
    dispatch(removeCartList());
    dispatch(removeCustomerAddress());
};

export default clearCustomerSession;
